import { Controller } from "@hotwired/stimulus"

// disconnect-hygiene: skip
// The window listeners below are registered once globally (guarded by
// window._pwaInstallState) so they intentionally persist across Turbo
// navigations — they're not per-instance.

// Cache prompt globally so it survives Turbo navigations
if (!window._pwaInstallState) {
  window._pwaInstallState = { deferredPrompt: null, installed: false }

  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault()
    window._pwaInstallState.deferredPrompt = e
  })

  window.addEventListener("appinstalled", () => {
    window._pwaInstallState.installed = true
    window._pwaInstallState.deferredPrompt = null
  })
}

export default class extends Controller {
  static targets = ["installButton", "iosButton", "iosInstructions", "installed"]

  connect() {
    this.standalone = window._pwaInstallState.installed ||
                      window.matchMedia("(display-mode: standalone)").matches ||
                      window.navigator.standalone === true

    if (this.standalone) {
      this.hideAll()
      this.installedTargets.forEach((el) => el.classList.remove("hidden"))
      return
    }

    if (window._pwaInstallState.deferredPrompt) {
      this.installButtonTargets.forEach((el) => el.classList.remove("hidden"))
    } else if (this.isIos) {
      this.iosButtonTargets.forEach((el) => el.classList.remove("hidden"))
      this.installButtonTargets.forEach((el) => el.classList.remove("hidden"))
    }
  }

  install() {
    const prompt = window._pwaInstallState.deferredPrompt
    if (prompt) {
      prompt.prompt()
      prompt.userChoice.then(() => {
        window._pwaInstallState.deferredPrompt = null
      })
    } else if (this.isIos) {
      this.showIos()
    }
  }

  showIos() {
    this.iosInstructionsTargets.forEach((el) => el.classList.remove("hidden"))
  }

  dismissIos() {
    this.iosInstructionsTargets.forEach((el) => el.classList.add("hidden"))
  }

  get isIos() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
           (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  }

  get installable() {
    return !this.standalone && (!!this.deferredPrompt || this.isIos)
  }

  // private

  showInstallButtons() {
    this.installButtonTargets.forEach((el) => el.classList.remove("hidden"))
  }

  showIosInstructions() {
    this.iosInstructionsTargets.forEach((el) => el.classList.remove("hidden"))
  }

  hideAll() {
    this.installButtonTargets.forEach((el) => el.classList.add("hidden"))
  }
}
